<div id="page_1" class="h-screen backdrop-filter backdrop-blur-lg">
  <div class="content">
    <h1 class="text-2xl sm:text-3xl md:text-4xl mb-2 font-light">
      <b>
        DoktorDoktor -<br>
        Die Vertretungsplattform für<br class="hidden sm:block">
        Ärztinnen und Ärzte.
      </b>
    </h1>
    <h2 class="text-xl md:text-3xl">
      Es gibt jemanden, der für Sie da ist.
    </h2>
    <a href="https://portal.doktordoktor.at/auth/sign-up" target="_blank" class="btn inline-block w-full max-w-sm sm:w-auto mt-5 mr-5 py-3 px-10 text-sm sm:text-lg">Kostenlos registrieren</a>
    <a href="https://portal.doktordoktor.at" target="_blank" class="btn inline-block w-full max-w-sm sm:w-auto mt-5 py-3 px-10 text-sm sm:text-lg">Einloggen</a>
  </div>
  <div class="footer justify-center">
    <button (click)="scrollToElement(contentStart)" class="btn py-3 px-6 bg-primary text-white block m-auto text-sm">Mehr erfahren</button>
    <img src="/assets/img/scroll.svg" alt="scroll" class="w-4 animate-bounce mt-5 m-auto" />
  </div>
</div>
<div id="page_2" #contentStart class="py-10 px-10 bg-gray">
  <div class="justify-center m-auto max-w-screen-lg">
    <iframe class="md:w-4/5 w-full m-auto md:h-96 h-60 mb-5" width="560" height="315" src="https://www.youtube-nocookie.com/embed/MN_6sceGdO4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <img src="/assets/img/logo.svg" alt="DoktorDoktor Logo" class="max-w-md lg:max-w-xl m-auto" />
    <div class="my-8 md:mx-20">
      <p>
        DoktorDoktor, die erste Vertretungsplattform für Ärztinnen und Ärzte, eröffnet Ihnen einen schnellen und praktischen Weg, eine Vertretung für die eigene Praxis zu finden oder selbst eine solche Vertretung zu übernehmen.
      </p>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-x-16 lg:gap-x-28 gap-y-12 my-14">
      <div>
        <div class="md:h-40 mb-5">
          <img src="/assets/img/dr-erreichbar.svg" alt="Überall erreichbar" class="w-3/5  m-auto" />
        </div>
        <h3 class="text-center font-bold text-base mb-3">
          Überall erreichbar
        </h3>
        <p>
          Mit DoktorDoktor können Sie direkt auf dem Webportal einen Suchauftrag mit allen wesentlichen Anforderungen (medizinische Fachrichtung, Vertretungszeitraum, Ordinationszeiten, Praxisort) erstellen. Oder umgekehrt unter Anwendung der entsprechenden Filter eine passende Vertretungsstelle finden. 
        </p>
      </div>
      <div>
        <div class="md:h-40 mb-5">
          <img src="/assets/img/dr-effizient.svg" alt="Effizient und sicher" class="w-1/2 m-auto" />
        </div>
        <h3 class="text-center font-bold text-base mb-3">
          Effizient und sicher
        </h3>
        <p>
          Der Abgleich der Ergebnisse erfolgt über die Plattform. Sie müssen nur noch Kontakt aufnehmen – der Rest ist Vereinbarungssache. Die Suche nach einer Vertretung ist zu drei günstigen Tarifen möglich. Und das Beste: DoktorDoktor ist kostenlos für alle, die gerne eine Vertretung übernehmen möchten. 
        </p>
      </div>
      <div>
        <div class="md:h-40 mb-5">
          <img src="/assets/img/dr-verlaesslich.svg" alt="Verlässlich und partnerschaftlich" class="w-3/5 m-auto" />
        </div>
        <h3 class="text-center font-bold text-base mb-3">
          Verlässlich und partnerschaftlich
        </h3>
        <p>
          DoktorDoktor stellt Ihnen für den von Ihnen gewünschten Zeitraum verlässlich sämtliche Funktionen der Plattform zur Verfügung. Das macht DoktorDoktor zum perfekten Partner an ihrer Seite und ideal auch für kurzfristig erforderliche Vertretungen. Setzen auch Sie auf DoktorDoktor - einfach kostenlos registrieren und auswählen, ob Sie eine Vertretung suchen oder selbst vertreten möchten. 
        </p>
      </div>
    </div>  
  </div>
</div>
<div id="page_3">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-0">
    <div class="bg-primary text-white">
      <div class="max-w-screen-sm float-right lg:mr-24 m-10">
        <h1 class="text-4xl md:text-5xl font-light mb-6 sm:mb-12 text-white">Es gibt jemanden, der für Sie da ist!</h1>
        <p>DoktorDoktor ist als Online-Portal die ideale und moderne Lösung, um eine Vertretung für die Arztpraxis zu suchen oder zu finden. Eine Suchfunktion mit Abgleich der wesentlichen Anforderungen wie Fachrichtung, Einsatzgebiet oder Vertretungszeitraum ermöglicht eine zielgerichtete Auswahl und bietet damit DIE perfekte Lösung für beide Seiten. Als Praxisbetreiber oder Verantwortlicher für ein Ärztezentrum profitieren Sie von folgenden Vorteilen:</p>
        <div class="flex mt-12 my-6">
          <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
          <div class="flex-grow">Aufrechterhaltung des Laufenden Betriebes
            <br><span class="text-sm">(Bei Weiterbildung bzw. Fortbildungskurse, Urlaub oder längerer Krankheit)</span>
          </div>
        </div>
        <div class="flex my-6">
          <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
          <div class="flex-grow">Besserer Service für Patienten
            <br><span class="text-sm">(Behandlung in der vertrauten Umgebung, längere Öffnungszeiten)</span></div>
        </div>
        <div class="flex my-6">
          <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
          <div class="flex-grow">Kein Verdienstentgang
            <br><span class="text-sm">(Laufende Einnahmen durch den Vertretungsdienst)</span></div>
        </div>
        <div class="flex my-6">
          <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
          <div class="flex-grow">Mehr Freizeit
            <br><span class="text-sm">(Für Familie und Hobbys)</span></div>
        </div>
        <div class="flex my-6">
          <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
          <div class="flex-grow">Spontane Reaktionsmöglichkeiten
            <br><span class="text-sm">(Bei kurzfristigen Verhinderungen Krankheit todesfall usw.)</span></div>
        </div>
      </div>
    </div>
    <div class="bg-cover bg-center" style="background-image: url(/assets/img/img2.jpg)">
      <!-- <img src="/assets/img/img2.jpg" alt="Es gibt jemanden, der für Sie da ist" class="w-full h-full" /> -->
    </div>
  </div>  
</div>
<div id="page_4" class="p-10 sm:p-14 md:p-20 backdrop-filter backdrop-blur-lg">
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-0">
    <div class="col-start-2">
      <h1 class="text-3xl md:text-5xl mb-6 sm:mb-12 sm:pl-5 font-light">
        Wenn Sie eine<br> Vertretung suchen …
      </h1>
      <ul class="bg-white max-w-3xl bg-opacity-70 mt-5 p-8 sm:p-14 py-5 sm:py-10 rounded-xl list-disc">
        <li>Sie hätten gerne mehr Zeit für Freizeit und Familie?</li>
        <li>Sie möchten Ihren Urlaub genießen?</li>
        <li>Oder sich weiterbilden, ohne Ihre Praxis zu schließen?</li>
        <li>Sie sind durch Krankheit eine Zeit lang verhindert?</li>
        <li>Sie möchten Ihren Patienten längere Öffnungszeiten bieten?</li>
        <li>Oder Sie sind in einem Ärztezentrum dafür verantwortlich, dass alle Praxen durchgehend besetzt sind?</li>
      </ul>
    </div>
  </div>  
</div>
<div id="page_5" class="py-16 px-10 bg-gray" > 
  <div class="justify-center m-auto max-w-screen-xl">
    <h1 class="text-white text-center justify-center text-3xl md:text-4xl mb-12 sm:pl-5 font-light">
      Dann ist <img src="/assets/img/logo.svg" alt="DoktorDoktor Logo" class="w-56 inline" /> genau das Richtige für Sie.
    </h1>
    <div class="my-8 md:mx-12">
      <p>
        Für eine günstige Jahrespauschale können Sie jederzeit und so oft Sie wollen auf der Web-Plattform einen Suchauftrag für die Vertretung mit den wichtigsten Kriterien von der Fachrichtung bis zum Vertretungszeitraum anlegen. Im Dashboard sehen Sie alle eintreffenden Bewerbungen und können direkt Kontakt aufnehmen.
      </p>
    </div>
    <div class="mb-2 mt-16 md:mx-12">
      <h2 class="text-white text-center justify-center text-1xl md:text-2xl mb-6 font-light">
        Vorteile
      </h2>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 max-w-screen-lg m-auto items-center justify-center">
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Mehr Work-Life-Balance</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Mehr Zeit für Freizeit, Familie und Weiterbildung</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Kein Verdienstentgang</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Einfache Administration</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Günstige Pauschaltarife</div>
      </div>
    </div>
  </div>
</div>
<div id="page_6" class="p-10 sm:p-14 md:p-40 backdrop-filter backdrop-blur-lg" >
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-0">
    <div class="col-start-1">
      <h1 class="text-3xl md:text-5xl mb-6 sm:mb-12 sm:pl-5 font-light">
        Wenn Sie selbst<br> vertreten möchten …
      </h1>
      <ul class="bg-white max-w-3xl bg-opacity-70 mt-5 p-8 sm:p-14 py-5 sm:py-10 rounded-xl list-disc">
        <li>Sie sind angestellt und haben daneben stunden- oder tageweise Zeit, in Ihrer Fachrichtung zu praktizieren?</li>
        <li>Sie möchten gerne etwas dazu verdienen?</li>
        <li>Sie würden gerne an einem Ort Ihrer Wahl tätig sein?</li>   
      </ul>
    </div>
  </div>  
</div>
<div id="page_7" class="py-16 px-10 bg-primary" > 
  <div class="justify-center m-auto max-w-screen-xl">
    <h1 class="text-white text-center justify-center text-3xl md:text-4xl mb-6 sm:mb-12  sm:pl-5 font-light">
      Dann melden Sie sich jetzt gleich bei <img src="/assets/img/logo-white.svg" alt="DoktorDoktor Logo" class="w-56 inline" /> an!
    </h1>
    <div class="my-8 md:mx-12">
      <p class="text-white">
        Sie können sich völlig kostenlos auf unserer Web-Plattform für Vertretungen bewerben und dabei nach allen wesentlichen Kriterien – von der gewünschten Fachrichtung bis zu Vertretungszeitraum - filtern.  ber Ihre Bewerbung kann der Auftraggeber direkt mit Ihnen in Kontakt treten.
      </p>
    </div>
    <div class="mb-2 mt-16 md:mx-12">
      <h2 class="text-white text-center justify-center text-1xl md:text-2xl mb-6 font-light">
        Vorteile
      </h2>
    </div>

    <div class="grid text-white grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 max-w-screen-lg m-auto items-center justify-center">
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Zusatz-Verdienst</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Einfach und zeitsparend</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Völlig kostenlos</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Gezielte Suche nach Vertretungsmöglichkeiten</div>
      </div>
      <div class="flex my-3">
        <div class="flex-none w-10"><span class="material-icons">check_circle</span></div>
        <div class="flex-grow">Ohne Verpflichtungen</div>
      </div>
    </div>
  </div>
</div>
<div id="page_8" class="py-16 px-10 bg-alt-gray" > 
  <div class="justify-center m-auto max-w-screen-xl">
    <h1 class="text-white text-center justify-center text-4xl md:text-5xl mb-12 font-light">
      Pakete
    </h1>
      <div class="grid grid-cols-1 md:grid-cols-2 md:gap-x-6 lg:gap-x-16 gap-y-8 md:gap-y-12 my-14">
        <div class="w-full md:w-4/5 mx-auto bg-white">
          <div class="text-lg h-24 font-medium bg-primary text-white p-8 text-center border-b border-gray-200 tracking-wide">
            Ich möchte vertreten
          </div>
          <div class="block sm:flex md:block lg:flex items-center justify-center">
            <div class="mt-4 mb-8 sm:m-8 md:m-0 md:mt-4 md:mb-8 lg:m-8 text-center">
              <div class="inline-flex items-center">
                <span class="text-3xl font-medium">Kostenlos</span>
              </div>
            </div>
          </div>

          <div class="flex justify-center mx-3 pb-8">
            <ul>
              <li class="flex items-center">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Attraktiver Zusatzverdienst</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Gezielte Suche nach<br> Vertretungsmöglichkeiten</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Einfach und zeitsparend</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Ohne Verpflichtungen</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Völlig kostenlos</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="w-full md:w-4/5 mx-auto bg-white">
          <div class="text-lg h-24 font-medium bg-primary text-white p-5 text-center border-b border-gray-200 tracking-wide">
            Ich suche eine Vertretung<br>für meine Ordination
          </div>
          <!-- <div class="block sm:flex md:block lg:flex items-center justify-center">
            <div class="mt-4 mb-8 sm:m-8 md:m-0 md:mt-4 md:mb-8 lg:m-8 text-center">
              <div class="inline-flex items-center items-baseline">
                <span class="text-3xl font-medium">€ 657</span>
                <span class="text-gray ml-2">inkl. USt.</span>
                
              </div>
              <div class="text-lg">per annum und Ordination</div>
            </div>
          </div> -->
          <div class="block sm:flex md:block lg:flex items-center justify-center">
            <div class="mt-4 mb-8 sm:m-8 md:m-0 md:mt-4 md:mb-8 lg:m-8 text-center">
              <div class="inline-flex items-center items-baseline">
                <span class="text-3xl font-medium">Kostenlos</span>
              </div>
              <div class="text-lg text-gray-500">Ab der 2. Ordination € 657 inkl. USt.<br> per annum und Ordination</div>
            </div>
          </div>
          <div class="flex justify-center mx-3 pb-8">
            <ul>
              <li class="flex items-center">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Einfache Administration</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Zeitersparnis</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Mehr Freizeit</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Kein Verdienstentgang</span>
              </li>
              <li class="flex items-center mt-3">
                <span class="material-icons text-primary">check_circle</span>
                <span class="text-gray-700 text-lg ml-3">Günstiger Pauschaltarif</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="md:col-span-2 text-center">
          <a href="https://portal.doktordoktor.at/auth/sign-up" target="_blank" class="btn inline-block mt-14 py-5 px-10 m-auto  text-xl">Jetzt Kostenlos registrieren</a>
        </div>
      </div>
  </div>
</div>
